import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import EngineFunctionsDefinition from '../../../definitions/engineFunctionsDefinition';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';
import $ from 'jquery';

/* Actions */
import * as polynomialAdminActions from '../../actions/polynomialAdmin/index';
import * as formulaEditorActions from '../../actions/formulaEditor/index';
import * as tableEditorActions from '../../actions/tableEditor/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/polynomialAdmin/formPopup';
import VersionDetailPopup from '../../components/polynomialAdmin/versionDetailPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import CheckBox from '../../components/common/inputs/checkBox';
import FormulaEditor from '../formulaEditor';
import TableEditor from '../tableEditor';
import EntityUseQuery from '../entityUseQuery';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  formPopup: "formPopup",
  polynomialVersionPopup: "polynomialVersionPopup",
  formulaEditorPopup: "formulaEditorPopup",
  tableEditorPopup: "tableEditorPopup",
  entityUseQuery: "entityUseQuery",
  closeFormConfirmPopup: "closeFormConfirmPopup",
  deleteVersionConfirmPopup: "deleteVersionConfirmPopup",
  restorePolynomialVersionConfirmPopup: "restorePolynomialVersionConfirmPopup",
}

const tableDefinitionEmptyState = {
  options: {},
  columns: [],
  columns_display: [{
    name: intl.formatMessage({id: "polynomialAdmin.tableEditor.valueColumnLabel"}),
    prop: "_0"
  }],
  instances: []
}

class PolynomialAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false,
        showOnlyModels: false,
        showOnlySubModels: false,
        showOnlyTables: false,
        selectedTags: [],
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.polynomialList,
      entityApiKey: "polynomial",      
      initialNewEntity: { formula_type: Constants.selectKeys.polynomial.formulaType.FORMULA, model: false, kpi: false, sub_model: false, 
                        display_report: true, display_report_formula: false, exclude_model_from_reports: false, 
                        hide_model_from_reports_if_zero: false, exclude_from_ux_active_models_lists: false,
                        exclude_model_from_calculation_reports: false, new_page_for_model: false,
                        report_hide_total_block: false, report_only_first_line_header: false, report_details: [],
                        detail_lineal_array: [], goal_lineal_array: [], formula_lineal_array: [], tags: [] },
      pendingSaveFields: {},
      entityUseQueryId: "",
      formulaEditorOptions: {}
    };
  }
 
  async componentDidMount() {
    EntityTableTooling.fetchList(this);
    this.props.actions.getDimensionsList();
    this.props.actions.getTagsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "polynomialAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "polynomialAdmin.entityNamePlural"})),
      intl.formatMessage({id: "polynomialAdmin.genderVocal"}),
      (this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : ""),
      (this.props.save.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.save.errors.message : ""),
      true
    );
    
    //preload polynomial
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.preloadPolynomial.status],
      [this.props.preloadPolynomial.status],
      null,
      intl.formatMessage({ id: "common.errors.conectionError" }),
      [() => {
        let entityObject = {};
        entityObject[this.state.entityApiKey] = this.props.preloadPolynomial.data;
        if(this.props.save.data && this.props.save.data["clone"]) {
          delete entityObject[this.state.entityApiKey]["id"];
        }
        this.props.actions.resetSaveEntity(entityObject);
      }]  
    );
        
    //handle formula validation
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.formulaValidation.status],
      [this.props.formulaValidation.status],
      intl.formatMessage({ id: "polynomialAdmin.formulaEditor.validateAndSetButtonSucces" }),
      this.props.formulaValidation.status!=422 ? 
        intl.formatMessage({ id: "common.errors.conectionError" }) : 
        intl.formatMessage({ id: "polynomialAdmin.formulaEditor.validateAndSetButtonError" }),
      [() => {
        this.props.actions.setSaveEntityDataByKey(this.props.formulaValidation.data.path, this.props.formulaValidation.data.formulaArray);
        if(this.props.formulaValidation.data.finalPath == "polynomial.formula") {
          this.props.actions.setSaveEntityDataByKey("polynomial.marks_list", this.props.formulaValidation.data.new_marks_list);
        }
        this.props.actions.setSaveEntityDataByKey(this.props.formulaValidation.data.finalPath, this.props.formulaValidation.data.formula);
        if(this.state.formulaEditorOptions.isVersionRestoring){
          this.restorePolynomialVersion();
        }
        else{
          let newPendingSaveFields = JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);
          newPendingSaveFields[this.props.formulaValidation.data.finalPath] = true;
          this.setState({
            pendingSaveFields: newPendingSaveFields
          });
        }
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.formulaEditorPopup])) {
          InterfaceTooling.popupHide(popupIds.formulaEditorPopup, this.setState.bind(this));
        }
      }]  
    );
    
    //handle table validation
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.tableValidation.status],
      [this.props.tableValidation.status],
      intl.formatMessage({ id: "polynomialAdmin.tableEditor.validateAndSetButtonSucces" }),
      this.props.tableValidation.status!=422 ? 
        intl.formatMessage({ id: "common.errors.conectionError" }) : 
        intl.formatMessage({ id: "polynomialAdmin.tableEditor.validateAndSetButtonError" }),
      [() => {
        this.props.actions.setSaveEntityDataByKey(this.props.tableValidation.data.path, [this.props.tableValidation.data.formulaArray]);
        if(this.state.formulaEditorOptions.isVersionRestoring){
          this.restorePolynomialVersion();
        }
        else{
          let newPendingSaveFields = JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);
          newPendingSaveFields[this.props.tableValidation.data.finalPath] = true;
          this.setState({
            pendingSaveFields: newPendingSaveFields
          });
        }
        this.props.actions.setSaveEntityDataByKey(this.props.tableValidation.data.finalPath, this.props.tableValidation.data.formula);
          if(InterfaceTooling.popupHasToRender(this.state[popupIds.tableEditorPopup])) {
          InterfaceTooling.popupHide(popupIds.tableEditorPopup, this.setState.bind(this));
        }
      }]  
    );
    
    //handle delete polynomial version
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.deleteVersion.status],
      [this.props.deleteVersion.status],
      intl.formatMessage({ id: "polynomialAdmin.deleteVersionSuccess" }),
      this.props.deleteVersion.status==406 ?
        intl.formatMessage({id: "common.entity.saveEntityCantDeactivateError"},
          {entityNameSingular: FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "polynomialAdmin.entityNameSingularWithArticleVersion"})),
           detail: (this.props.deleteVersion.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.deleteVersion.errors.message : "")
          }) :
      this.props.deleteVersion.status==423 ?
        intl.formatMessage({ id: "common.errors.systemLockedError" }) :
        intl.formatMessage({ id: "polynomialAdmin.deleteVersionFailure" }),
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.deleteVersionConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.deleteVersionConfirmPopup, this.setState.bind(this));
        }
        let oldPolynomialVersions = JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "polynomial.polynomial_versions");
        JavascriptUtilsTooling.setObjectStringPathKeyValue(this.props.save.data, "polynomial.polynomial_versions", oldPolynomialVersions.filter(version => version.id != this.props.deleteVersion.id))   
      }]    
    );

    if(prevProps.restorePolynomialVersion.status!=200 && this.props.restorePolynomialVersion.status==200) {
      if(this.props.restorePolynomialVersion.data.formula_type == Constants.selectKeys.polynomial.formulaType.FORMULA) {
        this.handleShowRestoringFormulaEditorPopup();
      }
      else if(this.props.restorePolynomialVersion.data.formula_type == Constants.selectKeys.polynomial.formulaType.TABLE) {
        this.handleShowRestoringTableEditorPopup();
      }
      if(InterfaceTooling.popupHasToRender(this.state[popupIds.restorePolynomialVersionConfirmPopup])) {
        InterfaceTooling.popupHide(popupIds.restorePolynomialVersionConfirmPopup, this.setState.bind(this));
      }
    }
  }
  
  fetchListCallback = async () => {
    await this.props.formulaEditorActions.getPolynomialsList();
  };
  
  getListQueryParams(defaultQueryParams) {
    let newQueryParams = defaultQueryParams;
    let fieldsAre = [];
    let searchesAre = [];
    if(!this.state.topControlsFormData.showDisabledEntities) {
      fieldsAre.push("active");
      searchesAre.push(true);
    }
    if(this.state.topControlsFormData.showOnlyModels) {
      fieldsAre.push("model");
      searchesAre.push(true);
    }
    if(this.state.topControlsFormData.showOnlySubModels) {
      fieldsAre.push("sub_model");
      searchesAre.push(true);
    }    
    if(this.state.topControlsFormData.showOnlyTables) {
      newQueryParams.show_only_tables = true;
    }    
    newQueryParams.fields_are = fieldsAre;
    newQueryParams.searches_are = searchesAre;
    
    let tags_filter = [];
    if(this.state.topControlsFormData.selectedTags.length > 0) {
      tags_filter = this.state.topControlsFormData.selectedTags;
    }
    newQueryParams.tags_filter = tags_filter;

    return newQueryParams;
  }

  handleShowPolynomialVersionPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.polynomialVersionPopup, this.state, 
      this.setState.bind(this), false, () => {
        let versionObject = JSON.parse(event.currentTarget.dataset.entitydata);
        this.props.actions.getPolynomialVersion({
          id: versionObject.id
        });  
      }
    );
  };

  handleShowFormPopup = (event) => {
    InterfaceTooling.handleShowClosePopup(
      event, popupIds.formPopup, popupIds.closeFormConfirmPopup, this.state, 
      this.setState.bind(this), (this.props.save.loading || this.props.preloadPolynomial.loading), () => {
        let entityObject = {};
        if(event.currentTarget.dataset.entitydata) {
          let parsedObject = JSON.parse(event.currentTarget.dataset.entitydata)
          entityObject[this.state.entityApiKey] = JavascriptUtilsTooling.deepCopy(this.state.initialNewEntity);
          this.props.actions.resetSaveEntity(entityObject);
          this.props.actions.getPolynomial({
            id: parsedObject.id
          });
        }
        else {
          entityObject[this.state.entityApiKey] = JavascriptUtilsTooling.deepCopy(this.state.initialNewEntity);
          entityObject.isEmpty = true;
          this.props.actions.resetSaveEntity(entityObject);
        }
        this.setState({
          pendingSaveFields: {}
        });
      }
    );
  };

  handleShowFormPopupToClone = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.formPopup, this.state, 
      this.setState.bind(this), (this.props.save.loading || this.props.preloadPolynomial.loading), () => {
        let entityObject = {};
        let parsedObject = JSON.parse(event.currentTarget.dataset.entitydata)
        entityObject[this.state.entityApiKey] = JavascriptUtilsTooling.deepCopy(this.state.initialNewEntity);
        entityObject["clone"] = true;
        this.props.actions.resetSaveEntity(entityObject);
        this.props.actions.getPolynomial({
          id: parsedObject.id
        });
        this.setState({
          pendingSaveFields: {}
        });
      }
    );
  };

  handleOnChangeForm = (event) => {    
    if(event.currentTarget.dataset.objecteditor) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = JSON.parse(event.currentTarget.dataset.value);
      let isDelete = event.currentTarget.dataset.delete;
      let isEdit = event.currentTarget.dataset.edit;
      let objectDefinition = [];
      
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      
      if(isDelete) { 
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } else if(isEdit) {
        objectDefinition[index] = objectValue;
      } else {
        objectDefinition.push(objectValue);
      }      
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,objectDefinition);
    }
    else if(event.currentTarget.dataset.tagslist){
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = event.currentTarget.dataset.value
      let isDelete = event.currentTarget.dataset.delete;
      let objectDefinition = [];
      
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      
      if(isDelete) { 
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } else {
        if(objectDefinition.includes(objectValue)) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({id: "common.errors.duplicatedTag"}));
        }
        else if(objectDefinition.map(item => item.toLowerCase()).includes(objectValue.toLowerCase())) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({id: "common.errors.duplicatedNonCapitalizedTag"}));
        } 
        else{
          objectDefinition.push(objectValue);
        }
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path, objectDefinition);
      this.setState({ formHasChanges: true });
    }
    else {
      if(event.currentTarget.dataset.path == "polynomial.formula_type") {
        this.props.actions.setSaveEntityDataByKey("polynomial.formula_lineal_array",[]);
        this.props.actions.setSaveEntityDataByKey("polynomial.formula","");
      }
      else if(event.currentTarget.dataset.path == "polynomial.model") {
        this.props.actions.setSaveEntityDataByKey("polynomial.exclude_model_from_reports",false);
        this.props.actions.setSaveEntityDataByKey("polynomial.hide_model_from_reports_if_zero",false);
        this.props.actions.setSaveEntityDataByKey("polynomial.exclude_model_from_calculation_reports",false);        
        this.props.actions.setSaveEntityDataByKey("polynomial.exclude_from_ux_active_models_lists",false);
        this.props.actions.setSaveEntityDataByKey("polynomial.new_page_for_model",false);
        this.props.actions.setSaveEntityDataByKey("polynomial.sub_model",false);
        this.props.actions.setSaveEntityDataByKey("polynomial.sub_model_dimension_id","");
      }
      else if(event.currentTarget.dataset.path == "polynomial.sub_model") {
        this.props.actions.setSaveEntityDataByKey("polynomial.model",false);       
        this.props.actions.setSaveEntityDataByKey("polynomial.exclude_from_ux_active_models_lists",false);
      }
      EntityTableTooling.handleOnChangeForm(this, event);
    }       
    let currentPendingFields = JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);
    currentPendingFields[event.currentTarget.dataset.path] = true;
    this.setState({
      pendingSaveFields: currentPendingFields
    }); 
  };

  handleShowFormulaEditorPopup = (event) => {
    InterfaceTooling.handleShowClosePopup(
      event, popupIds.formulaEditorPopup, popupIds.closeFormulaConfirmPopup, this.state, 
      this.setState.bind(this), false, () => {
        let path = event.currentTarget.dataset.path;
        let label = event.currentTarget.dataset.label;
        let disableMarkMode = event.currentTarget.dataset.disablemarkmode == "true" ? true : false;
        let disableFunctions = event.currentTarget.dataset.disablefunctions;
        let finalPath = event.currentTarget.dataset.finalpath;        
        let onlyRead = event.currentTarget.dataset.onlyread;
        let propsTarget = event.currentTarget.dataset.propstarget;
        propsTarget = propsTarget ? propsTarget : "save";
        disableFunctions = disableFunctions ? JSON.parse(disableFunctions) : []
        
        let formulaObject = {};      
        let formulaArray = [];
        if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props[propsTarget].data, path)) {
          formulaArray = JavascriptUtilsTooling.deepCopy(
            JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props[propsTarget].data, path)
          );
        }
        formulaObject.path = path;
        formulaObject.finalPath = finalPath;
        formulaObject.label = label;
        formulaObject.onlyRead = onlyRead;
        formulaObject.marks_list = (this.props[propsTarget].data && this.props[propsTarget].data.polynomial && this.props[propsTarget].data.polynomial.marks_list) ? this.props[propsTarget].data.polynomial.marks_list : {};
        formulaObject.formulaArray = formulaArray;
        this.props.formulaEditorActions.setFormulaToEditObject(FormulaUtilsTooling.changeCollapseAllEntity(formulaObject, "false"));
        this.setState({
          formulaEditorOptions: {
            disableMarkMode: disableMarkMode,
            disableFunctions: disableFunctions,
            isVersionRestoring: false,
          }
        });
      }
    );
  };

  handleShowTableEditorPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.tableEditorPopup, this.state, 
      this.setState.bind(this), false, () => {
        let path = event.currentTarget.dataset.path;
        let finalPath = event.currentTarget.dataset.finalpath;
        let onlyRead = event.currentTarget.dataset.onlyread;
        let propsTarget = event.currentTarget.dataset.propstarget;
        propsTarget = propsTarget ? propsTarget : "save";
        
        let formulaObject = {};
        let formulaArray = [];
        if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props[propsTarget].data, path)) {
          formulaArray = JavascriptUtilsTooling.deepCopy(
            JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props[propsTarget].data, path)
          );
        }
        formulaObject.path = path;
        formulaObject.is_table = true;
        formulaObject.marks_list = (this.props[propsTarget].data && this.props[propsTarget].data.polynomial && this.props[propsTarget].data.polynomial.marks_list) ? this.props[propsTarget].data.polynomial.marks_list : {};
        formulaObject.finalPath = finalPath;
        formulaObject.onlyRead = onlyRead;
        formulaObject.formulaArray = (formulaArray && formulaArray.length>0) ? formulaArray[0] : tableDefinitionEmptyState;
        let empty_row = {};
        let empty_rows = [];
        formulaObject.formulaArray.columns_display.forEach(item => { empty_row[item.prop] = ""; });
        for(let i=0;i<500;i++) {
          empty_rows.push(JavascriptUtilsTooling.deepCopy(empty_row));
        }
        formulaObject.formulaArray.instances = formulaObject.formulaArray.instances.concat(empty_rows);
        this.props.tableEditorActions.setFormulaToEditObject(formulaObject);
        this.setState({ formulaEditorOptions: { isVersionRestoring: false }});
      }
    );
  };

  handleEntityQueryDataPopup = event => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.entityUseQuery, this.state, 
      this.setState.bind(this), this.props.loadingEntityUseQueryData, () => {
        this.setState({
          entityUseQueryId: JSON.parse(event.currentTarget.dataset.entityid)
        });
      }
    );
  };

  handleDeletePolynomialVersion = async () => {
    await this.props.actions.deleteFormulaVersionEntity({id: this.props.deleteVersion.id});
  }

  handleDeletePolynomialVersionConfirmPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.deleteVersionConfirmPopup, this.state, 
      this.setState.bind(this), this.props.deleteVersion.loading, () => {
        this.props.actions.prepareDeleteFormulaVersionEntity(event.currentTarget.dataset.id);
      }
    );
    event.stopPropagation();
  }

  restorePolynomialVersion = () => {
    let versionHash = this.props.restorePolynomialVersion.data;
    let currentFormData = JavascriptUtilsTooling.deepCopy(this.props.save.data);
    let newPendingFields = JavascriptUtilsTooling.deepCopy(this.state.pendingSaveFields);
    
    this.props.actions.setSaveEntityDataByKey("polynomial.detail",versionHash.detail);
    newPendingFields["polynomial.detail"] = versionHash.detail==currentFormData.detail ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.detail_format",versionHash.detail_format);
    newPendingFields["polynomial.detail_format"] = versionHash.detail_format==currentFormData.detail_format ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.display_report",versionHash.display_report);   
    newPendingFields["polynomial.display_report"] = versionHash.display_report==currentFormData.display_report ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.exclude_model_from_calculation_reports",versionHash.exclude_model_from_calculation_reports);
    newPendingFields["polynomial.exclude_model_from_calculation_reports"] = versionHash.exclude_model_from_calculation_reports==currentFormData.exclude_model_from_calculation_reports ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.exclude_model_from_reports",versionHash.exclude_model_from_reports);
    newPendingFields["polynomial.exclude_model_from_reports"] = versionHash.exclude_model_from_reports==currentFormData.exclude_model_from_reports ? false : true;
    // this.props.actions.setSaveEntityDataByKey("polynomial.formula",versionHash.formula);
    newPendingFields["polynomial.formula"] = versionHash.formula_lineal_array==currentFormData.formula_lineal_array ? false : true;
    // this.props.actions.setSaveEntityDataByKey("polynomial.formula_lineal_array",versionHash.formula_lineal_array);
    newPendingFields["polynomial.formula_lineal_array"] = versionHash.formula_lineal_array==currentFormData.formula_lineal_array ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.formula_type",versionHash.formula_type);
    newPendingFields["polynomial.formula_type"] = versionHash.formula_type==currentFormData.formula_type ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.goal",versionHash.goal);
    newPendingFields["polynomial.goal"] = versionHash.goal==currentFormData.goal ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.goal_lineal_array",versionHash.goal_lineal_array);
    newPendingFields["polynomial.goal_lineal_array"] = versionHash.goal_lineal_array==currentFormData.goal_lineal_array ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.hide_model_from_reports_if_zero",versionHash.hide_model_from_reports_if_zero);
    newPendingFields["polynomial.hide_model_from_reports_if_zero"] = versionHash.hide_model_from_reports_if_zero==currentFormData.hide_model_from_reports_if_zero ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.kpi",versionHash.kpi);
    newPendingFields["polynomial.kpi"] = versionHash.kpi==currentFormData.kpi ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.marks_list",versionHash.marks_list);
    newPendingFields["polynomial.marks_list"] = versionHash.marks_list==currentFormData.marks_list ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.new_page_for_model",versionHash.new_page_for_model);
    newPendingFields["polynomial.new_page_for_model"] = versionHash.new_page_for_model==currentFormData.new_page_for_model ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.order",versionHash.order);
    newPendingFields["polynomial.order"] = versionHash.order==currentFormData.order ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.report_columns_number",versionHash.report_columns_number);
    newPendingFields["polynomial.report_columns_number"] = versionHash.report_columns_number==currentFormData.report_columns_number ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.report_details",versionHash.report_details);
    newPendingFields["polynomial.report_details"] = versionHash.report_details==currentFormData.report_details ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.report_hide_total_block",versionHash.report_hide_total_block);
    newPendingFields["polynomial.report_hide_total_block"] = versionHash.report_hide_total_block==currentFormData.report_hide_total_block ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.report_label",versionHash.report_label);
    newPendingFields["polynomial.report_label"] = versionHash.report_label==currentFormData.report_label ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.report_label_lineal_array",versionHash.report_label_lineal_array);
    newPendingFields["polynomial.report_label_lineal_array"] = versionHash.report_label_lineal_array==currentFormData.report_label_lineal_array ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.report_only_first_line_header",versionHash.report_only_first_line_header);
    newPendingFields["polynomial.report_only_first_line_header"] = versionHash.report_only_first_line_header==currentFormData.report_only_first_line_header ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.report_rich_description",versionHash.report_rich_description);
    newPendingFields["polynomial.report_rich_description"] = versionHash.report_rich_description==currentFormData.report_rich_description ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.return_type_format",versionHash.return_type_format);
    newPendingFields["polynomial.return_type_format"] = versionHash.return_type_format==currentFormData.return_type_format ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.stop_display_report",versionHash.stop_display_report);
    newPendingFields["polynomial.stop_display_report"] = versionHash.stop_display_report==currentFormData.stop_display_report ? false : true;
    this.props.actions.setSaveEntityDataByKey("polynomial.sub_model_dimension_id",versionHash.sub_model_dimension_id);
    newPendingFields["polynomial.sub_model_dimension_id"] = versionHash.sub_model_dimension_id==currentFormData.sub_model_dimension_id ? false : true;
    this.setState({
      pendingSaveFields: newPendingFields,
    });
  }

  handleShowRestoringFormulaEditorPopup = (event) => {
    InterfaceTooling.handleShowClosePopup(
      event, popupIds.formulaEditorPopup, popupIds.closeFormulaConfirmPopup, this.state, 
      this.setState.bind(this), false, () => {
        let path = "polynomial.formula_lineal_array"
        let label = intl.formatMessage({id: "polynomialAdmin.fields.formula"})
        let disableMarkMode = false;
        let disableFunctions = false
        let finalPath = "polynomial.formula";     
        let onlyRead = false;
        let propsTarget = "restorePolynomialVersion";
        disableFunctions = disableFunctions ? JSON.parse(disableFunctions) : []
        
        let formulaObject = {};      
        let formulaArray = this.props.restorePolynomialVersion.data.formula_lineal_array
        formulaObject.path = path;
        formulaObject.finalPath = finalPath;
        formulaObject.label = label;
        formulaObject.onlyRead = onlyRead;
        formulaObject.marks_list = (this.props[propsTarget].data && this.props[propsTarget].data.polynomial && this.props[propsTarget].data.polynomial.marks_list) ? this.props[propsTarget].data.polynomial.marks_list : {};
        formulaObject.formulaArray = formulaArray;
        this.props.formulaEditorActions.setFormulaToEditObject(FormulaUtilsTooling.changeCollapseAllEntity(formulaObject, "false"));
        this.setState({
          formulaEditorOptions: {
            disableMarkMode: disableMarkMode,
            disableFunctions: disableFunctions,
            isVersionRestoring: true,
          }
        });
      }
    );
  };

  handleShowRestoringTableEditorPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.tableEditorPopup, this.state, 
      this.setState.bind(this), false, () => {
        let path = "polynomial.formula_lineal_array"
        let finalPath = "polynomial.formula";
        let onlyRead = false;
        let propsTarget = "restorePolynomialVersion";
        
        let formulaObject = {};
        let formulaArray = this.props.restorePolynomialVersion.data.formula_lineal_array

        formulaObject.path = path;
        formulaObject.is_table = true;
        formulaObject.marks_list = (this.props[propsTarget].data && this.props[propsTarget].data.polynomial && this.props[propsTarget].data.polynomial.marks_list) ? this.props[propsTarget].data.polynomial.marks_list : {};
        formulaObject.finalPath = finalPath;
        formulaObject.onlyRead = onlyRead;
        formulaObject.formulaArray = (formulaArray && formulaArray.length>0) ? formulaArray[0] : tableDefinitionEmptyState;
        let empty_row = {};
        let empty_rows = [];
        formulaObject.formulaArray.columns_display.forEach(item => { empty_row[item.prop] = ""; });
        for(let i=0;i<500;i++) {
          empty_rows.push(JavascriptUtilsTooling.deepCopy(empty_row));
        }
        formulaObject.formulaArray.instances = formulaObject.formulaArray.instances.concat(empty_rows);
        this.props.tableEditorActions.setFormulaToEditObject(formulaObject);
        this.setState({ formulaEditorOptions: { isVersionRestoring: true }});
      }
    );
  };

  handleRestorePolynomialVersionConfirmPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.restorePolynomialVersionConfirmPopup, this.state, 
      this.setState.bind(this), this.props.restorePolynomialVersion.loading, () => {
        let versionObject = JSON.parse(event.currentTarget.dataset.entitydata);
        this.setState({ restorePolynomialVersionId: versionObject.id });
      }
    );
    event.stopPropagation();
  }

  handleConfirmRestorePolynomialVersion = async (event) => {
    this.props.actions.restorePolynomialVersion({
      id: this.state.restorePolynomialVersionId
    });
  }

  render() {
    var loadingView = this.props.list.firstLoading || this.props.tagsList.firstLoading;
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200) || 
      (this.props.tagsList.status !== null && this.props.tagsList.status !== 200);

    let tagsArray = (this.props.tagsList && this.props.tagsList.status == 200) ? this.props.tagsList.data : [];
    return (
      <section className="dashboard_content_inner_view entity_admin_container polynomial_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={this.handleShowFormPopup}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={this.handleShowFormPopup}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
                handleCustomActions={[this.handleShowFormPopupToClone]}
                customActionsIcons={["clone"]}
                customActionsTooltips={[
                  intl.formatMessage({ id: "common.entityTableActions.clone"})
                ]}
                enableTagsSearch={true}
                tagsOptions={tagsArray}
                extraControls={
                  <div>
                    <CheckBox 
                      className="top_controls_show_disabled_entities"
                      id="showOnlyModels"
                      value={this.state.topControlsFormData.showOnlyModels}
                      onChange={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                      labelLocale={<FormattedMessage id="polynomialAdmin.showOnlyModels"/>}
                    />
                    <CheckBox 
                      className="top_controls_show_disabled_entities"
                      id="showOnlySubModels"
                      value={this.state.topControlsFormData.showOnlySubModels}
                      onChange={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                      labelLocale={<FormattedMessage id="polynomialAdmin.showOnlySubModels"/>}
                    />
                    <CheckBox 
                      className="top_controls_show_disabled_entities"
                      id="showOnlyTables"
                      value={this.state.topControlsFormData.showOnlyTables}
                      onChange={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                      labelLocale={<FormattedMessage id="polynomialAdmin.showOnlyTables"/>}
                    />
                  </div>
                }
              />
              <FormPopup
                handleShowPopup={this.handleShowFormPopup}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading || this.props.preloadPolynomial.loading ||
                  this.props.saveUserImage.loading}
                statusButton={this.props.save.status}
                statusPreloading={this.props.preloadPolynomial.status}
                loadingPreloading={this.props.preloadPolynomial.loading}
                formData={this.props.save.data}
                pendingSaveFields={this.state.pendingSaveFields}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleShowPolynomialVersionPopup={this.handleShowPolynomialVersionPopup}
                handleEditFormulaLink={this.handleShowFormulaEditorPopup}
                handleEditTableLink={this.handleShowTableEditorPopup}
                handleEntityQueryDataPopup={this.handleEntityQueryDataPopup}
                popupState={EntityTableTooling.getFormPopupState(this)}
                handleDeletePolynomialVersion={this.handleDeletePolynomialVersionConfirmPopup}
                handleSaveUserImage={this.props.dashboardActions.saveUserImage}
                handleRestorePolynomialVersion={this.handleRestorePolynomialVersionConfirmPopup}
                dimensionsList={this.props.dimensionsList.data}
                tagsOptions={tagsArray}
              />
              <VersionDetailPopup
                handleShowPopup={this.handleShowPolynomialVersionPopup}
                versionData={this.props.polynomialVersion.data}
                dimensionsList={this.props.dimensionsList.data}
                handleEditFormulaLink={this.handleShowFormulaEditorPopup}
                handleEditTableLink={this.handleShowTableEditorPopup}
                fullLoading={this.props.polynomialVersion.loading}
                status={this.props.polynomialVersion.status}
                popupState={this.state[popupIds.polynomialVersionPopup]}
              />
              <EntityUseQuery
                popupState={this.state[popupIds.entityUseQuery]}
                entityDefaultType={Constants.selectKeys.entityUseQuery.entityTypes.POLYNOMIAL}
                entityDefaultId={this.state.entityUseQueryId}
                handleEntityQueryDataPopup={this.handleEntityQueryDataPopup}
              />
              <FormulaEditor
                handleShowFormulaEditorPopup={this.handleShowFormulaEditorPopup}
                formulaEditorOptions={this.state.formulaEditorOptions}
                popupState={this.state[popupIds.formulaEditorPopup]}
              /> 
              <TableEditor
                handleShowTableEditorPopup={this.handleShowTableEditorPopup}
                popupState={this.state[popupIds.tableEditorPopup]}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"polynomialAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"polynomialAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"polynomialAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.polynomial && this.props.save.data.polynomial.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"polynomialAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.polynomial && this.props.save.data.polynomial.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"polynomialAdmin.closePopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"polynomialAdmin.closePopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"polynomialAdmin.deleteVersionPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"polynomialAdmin.deleteVersionPopupDetail"}/>)}
                handleConfirm={this.handleDeletePolynomialVersion}
                handleCancel={this.handleDeletePolynomialVersionConfirmPopup}
                popupState={this.state[popupIds.deleteVersionConfirmPopup]}
                loading={this.props.deleteVersion.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"polynomialAdmin.restoreVersionPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"polynomialAdmin.restoreVersionPopupDetail"}/>)}
                handleConfirm={this.handleConfirmRestorePolynomialVersion}
                handleCancel={this.handleRestorePolynomialVersionConfirmPopup}
                popupState={this.state[popupIds.restorePolynomialVersionConfirmPopup]}
                loading={this.props.restorePolynomialVersion.loading}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.polynomialAdmin.list,
  save: state.reducer.polynomialAdmin.save,
  delete: state.reducer.polynomialAdmin.delete,
  polynomialVersion: state.reducer.polynomialAdmin.polynomialVersion,
  preloadPolynomial: state.reducer.polynomialAdmin.preloadPolynomial,
  loadingEntityUseQueryData: state.reducer.entityUseQuery.queryData.loading,  
  tableValidation: state.reducer.tableEditor.formulaValidation,  
  formulaValidation: state.reducer.formulaEditor.formulaValidation,
  deleteVersion: state.reducer.polynomialAdmin.deleteVersion,
  dimensionsList: state.reducer.polynomialAdmin.dimensionsList,
  saveUserImage: state.reducer.dashboard.saveUserImage,
  tagsList: state.reducer.polynomialAdmin.tagsList,
  restorePolynomialVersion: state.reducer.polynomialAdmin.restorePolynomialVersion,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(polynomialAdminActions, dispatch),
  formulaEditorActions: bindActionCreators(formulaEditorActions, dispatch),
  tableEditorActions: bindActionCreators(tableEditorActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

PolynomialAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PolynomialAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/polynomialAdmin/index.jsx